import React from "react"

const CallCenter = () => {
  return (
    <div
      style={{
        width: "2rem",
        height: "2rem",
        margin: "auto 0",
      }}
    >
      <svg viewBox="0 0 65 65">
        <path
          fill="#FFF"
          d="M38.9,55.4c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5c0,0,2.1,0,4.2-1.3c2.6-1.6,4-4.6,4-8.7
	c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5C50.1,55.3,39,55.4,38.9,55.4z"
        />
        <path
          fill="#FFF"
          d="M48.6,29.1c-0.8,0-1.5-0.7-1.5-1.5v-3.3c0-8.5-5.9-15-13.8-15h-1.6c-7.8,0-13.8,6.4-13.8,15v3.3
	c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5v-3.3c0-10.1,7.4-18,16.8-18h1.6c9.4,0,16.8,7.9,16.8,18v3.3C50.1,28.4,49.4,29.1,48.6,29.1
	z"
        />
        <path
          fill="#FFF"
          d="M52.1,43.9h-6.8c-0.8,0-1.5-0.7-1.5-1.5V27.6c0-0.8,0.7-1.5,1.5-1.5h6.8c2.4,0,4.4,2,4.4,4.5v8.9
	C56.5,41.9,54.5,43.9,52.1,43.9z M46.9,40.9h5.2c0.8,0,1.4-0.7,1.4-1.5v-8.9c0-0.8-0.6-1.5-1.4-1.5h-5.2V40.9z M19.6,43.9h-6.8
	c-2.4,0-4.4-2-4.4-4.5v-8.9c0-2.5,2-4.5,4.4-4.5h6.8c0.8,0,1.5,0.7,1.5,1.5v14.8C21.1,43.2,20.5,43.9,19.6,43.9z M12.9,29.1
	c-0.8,0-1.4,0.7-1.4,1.5v8.9c0,0.8,0.6,1.5,1.4,1.5h5.2V29.1H12.9z"
        />
        <path
          fill="#FFF"
          d="M35.7,58.7h-3.2c-2.6,0-4.7-2.2-4.7-4.8s2.1-4.8,4.7-4.8h3.2c2.6,0,4.7,2.2,4.7,4.8S38.3,58.7,35.7,58.7z
	 M32.5,52.1c-0.9,0-1.7,0.8-1.7,1.8s0.8,1.8,1.7,1.8h3.2c0.9,0,1.7-0.8,1.7-1.8s-0.8-1.8-1.7-1.8H32.5z"
        />
      </svg>
    </div>
  )
}

export default CallCenter
